import { Injectable, Inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Router } from '@angular/router';
import { WINDOW } from '@ng-toolkit/universal'
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { AuthorizationService } from '../../core/services/authorization.service';
import { _throw } from 'rxjs/observable/throw';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private router: Router, 
        private toastrService: ToastrService, 
        private authenticationService: AuthorizationService,
        @Inject(WINDOW) private window,
        ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(tap(res => {

        }), catchError(err => {
            console.log('error in interceptor', err);
            // if (err && err.status) {
            if (err.status === 401) {
                this.toastrService.error('Session Expired! Please login again.');
                this.authenticationService.resetStatus();
                this.router.navigate(['/login']);
                this.window.location.reload();
            }
            else {
                const error = err.error.message || 'Looks server is not reachable at this moment. Please try after sometime.';
                this.toastrService.error(error);
            }
            const errors = err.message || err;
            return throwError(errors);
            // }
            // return throwError(err.error);
        }));
    }
}